@file:kotlin.js.JsExport
/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2024] Narbase Technologies
 * All Rights Reserved.
 * Created by shalaga44
 * On: 24/Jul/2024.
 */

package com.narbase.letsgo.web.routing.domain.appSettings

data class PhoneNumber(val callingCode: Int, val localPhone: String) {
    @kotlin.js.JsName("fromParts")
    constructor(callingCode: String, localPhone: String) : this(
        callingCode = callingCode.filter { it.isDigit() }.toIntOrNull()
            ?: throw IllegalStateException("callingCode ($callingCode) is empty"),
        localPhone = localPhone
    )

    @kotlin.js.JsName("fromString")
    constructor(numberAsString: String) : this(
        callingCode = numberAsString.removePrefix("+").trim().dropLast(9).trim().toInt(),
        localPhone = numberAsString.removePrefix("+").trim().takeLast(9).trim(),
    )

    val numberAsStringWithLeadingPlus = "+$callingCode$localPhone"
}